/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter a name for the key" |
*
* @param {Options_Api_Keys_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_name_placeholder = /** @type {((inputs?: Options_Api_Keys_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisir un nom pour la clé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie einen Namen für den Schlüssel ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un nome per la chiave")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите название для ключа.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca un nombre para la clave")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入密钥的名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キーの名前を入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुंजी के लिए एक नाम दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira um nome para a chave.")
	return /** @type {LocalizedString} */ ("Enter a name for the key")
});